<template>
  <div :class="$style.formCaption"><slot /></div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.formCaption {
  margin-top: $space-75;

  @include body-2($color-grey-90);
}
</style>
<script setup lang="ts"></script>
